module.exports = __webpack_public_path__ + "img/headshot3.2efd7ede.png";